import { Injectable } from '@angular/core';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private socket$!: WebSocketSubject<any>;
  private conectionStatus: String = ''
  private url = environment.webSocket
  constructor() {
    this.createConnection()
    this.checkConection()
  }

  createConnection() {
    this.socket$ = webSocket({
          url: this.url,
          deserializer(e) {
            return (e.data).toString()
          },
        });
  }

  checkConection() {
    setInterval(() => {
          this.sendMessage('ping')
    },15000);
   /*     this.socket$.pipe().subscribe(
          message => this.conectionStatus = 'Conexão estabelecida, aguardando eventos!',
          error =>  this.conectionStatus = 'Conexão perdida!...Tentando reconectar',
          () => this.conectionStatus = 'Conexão perdida!...Renicie a pagina'
    );
    return this.conectionStatus*/
  }

  reciveMessage(){
    return this.socket$.pipe()
  }

  sendMessage(message: any) {
    this.socket$.next(message);
  }

  closeConnection() {
    this.socket$.complete();
  }
}

